import { consorsUserInitComponent } from "./consorsUserInit.component";

export const consorsUserInitStateName = "app.consorsUserInit";

export const consorsUserInitState = ($stateProvider) => {
	"ngInject";

	$stateProvider.state({
		url: "/go/:userId?exp?sig",
		name: consorsUserInitStateName,
		component: consorsUserInitComponent.name,
		params: {
			userId: null,
			exp: null,
			sig: null,
		},
	});
};



// WEBPACK FOOTER //
// ./src/app/components/consorsUserInit/consorsUserInit.state.js